// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApi: 'https://casa-bello-test.muukservices.com/api',
  urlPrinter: 'http://localhost',
  port: 8000,
  serial: 'M2QxNDYzOTZfXzIwMjUtMDktMTdfXzIwMjYtMDMtMTYjIyN3bkMyTzNpS3hCaHAraEt2YXp3ZTlDMFN3b2FycDBBSXNPRlRMWVBXd2hxbUFtVElLMnRUaWZzU1BoeDFHK2hBQXlYdjkxSUNEQU9abDhEMGx4N0xiTXkvYWZrUEI5T2d4LzNwZSt5bEZuOElyekM3K0NKZGU2WTBubUlyOFk4eEhMaVkrQWFvZUdsSUc0dDgvd09iUVd0bzZBRTJ6Q0R0cFoycmJBY1l6Y3daZWpDNzRUSm5IUTJ6K0VjU1RvaExwZ1UxQVRvVXBYc0x0L1JpVVNISnp2Zk9qYkFLSHlUNGw5L1VKZE0yYWVoQU5Ocy9XRExlRVMyUGJIa2pQc0x3MjRCS0tRM01vc2ZuR0lhN3ZxUHBUSmsrQzFYaEhQTk0rNXBGUTh1R2FZcGFxNDEvMDlLSXNuZkZqRWNWODFBOXp0R3pQRXFZVHhmdllhRTQzU3YrKzZhaXpiZ0kzRmd1U29FdlNrQ0NneEFFSVpUZVJNS2xHaFlsbTRsUytQZmFpZVBIT1Zyb3BlL0lYbWVTenpyMTcxajgwb0Fjc05ZeHFCdTh2WlhGazNDaTdyQSt1Ui9UM2pEL0dGUGR4SE42Z2dTbytxcU1RckZoWTNFYnZ2QlJQNCtZYkNCWHhCREovazVqQXpMK0xJRU9ibTA4bU52RWdBRW1WdTdYK0UyQzRXT0JESS9PeFlOb3dIT2J2ZFdSWUVHSlpwY3M4Qk9DakpqZ1NSQ2Vjam9VWXpZWHFiTUZqNzU3V0h3ZFlxWjhORkM0aGhxZ0xjZ3dZYUV0VmRFV285YUp3RjlMNFRVNXJMdmRvL1plY2xYNDdJL0h4bzgvYU9JNE1RNWRSSFI4eEhrUVU1cDVZUHFObTljeFNUeG1FRnFlWkErNnkydDkxNjdqdWtqTklwMD0=',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
